import { cn } from "../../utils/classNames";
import { getShowImage, titleInitials } from "../../utils/showDisplay";

export default function PosterFrame({ show, className = "", rank = null }) {
  const image = getShowImage(show);
  const title = show?.title || "Hook'd Pick";

  return (
    <div className={cn("relative overflow-hidden rounded-hookd border border-hookd-gold/25 bg-hookd-ink shadow-gold", className)}>
      {image ? (
        <img src={image} alt="" className="h-full w-full object-cover" />
      ) : (
        <div className="flex h-full min-h-44 w-full flex-col items-center justify-center bg-[linear-gradient(145deg,#1B1126,#050409)] p-4 text-center">
          <span className="mb-3 text-4xl text-hookd-gold">♕</span>
          <span className="font-display text-4xl font-bold text-hookd-cream">{titleInitials(title)}</span>
          <span className="mt-3 max-w-full text-sm font-bold uppercase text-hookd-gold">{title}</span>
        </div>
      )}
      {rank && (
        <span className="absolute left-3 top-3 rounded-md border border-hookd-empress/60 bg-hookd-purple px-2 py-1 text-xs font-bold text-white shadow-glow">
          {String(rank).padStart(2, "0")}
        </span>
      )}
    </div>
  );
}
